import { z } from 'zod'
import { normalizeTotpQrCodeSrc } from '../../utils/normalizeTotpQrCodeSrc'
import type { TwoFactorTotpSetup } from '../../models/TwoFactorTotpSetup'

export const TwoFactorTotpSetupDTO = z.object({
  setup_challenge_id: z.string().uuid(),
  qr_code: z.string(),
  manual_secret: z.string()
})

export type TwoFactorTotpSetupDTO = z.infer<typeof TwoFactorTotpSetupDTO>

export function mapDTOToTwoFactorTotpSetup (dto: TwoFactorTotpSetupDTO): TwoFactorTotpSetup {
  return {
    setupChallengeId: dto.setup_challenge_id,
    qrCode: normalizeTotpQrCodeSrc(dto.qr_code),
    manualSecret: dto.manual_secret
  }
}

export function mapTwoFactorTotpSetupToDTO (model: TwoFactorTotpSetup): TwoFactorTotpSetupDTO {
  return {
    setup_challenge_id: model.setupChallengeId,
    qr_code: model.qrCode,
    manual_secret: model.manualSecret
  }
}
